<template>
  <div style="min-height: 100%;background: #0B2481;">
    <Scroller :is-refresh-data.sync="refresh"
                :is-loading-data.sync="loading"
                :is-finished-data.sync="finished"
                :no-data-text-data.sync="noDataText"
                @on-infinite="onInfinite"
                @on-refresh="onRefresh"
                class="my_scroller"
                ref="my_scroller"

      >
      <div class="invFriends" @click="share">
        <img ref="ifscroll" :class="{'ceiling': ceil}" src="../../assets/images/friendbtn.png">
        <div class="list">
          <img src="../../assets/images/title.png">
          <ul>
            <li v-for="(item, index) of list" :key="index">
              <img v-if="item.head" :src="item.head" @error="function(event) {let img = event.srcElement;img.src = errorHeadImg; img.onerror = null;}">
              <img v-else :src="errorHeadImg">
              <div class="title">
                <p>{{item.smallname}}</p>
                <span>{{item.time}}</span>
              </div>
              <b v-if="parseInt(item.integralnum) > 0">+{{item.integralnum}}金币</b>
            </li>
          </ul>
        </div>
      </div>
      <div class="sharecontainer" v-if="showshare === true">
      <img src="../../assets/images/sharemc.png"/>
      <van-button round plain  type="danger" class="know"  @click="showshare = false">我知道</van-button>
    </div>
    </Scroller>
  </div>
</template>

<script>
import { customRequestAjax } from '@/axiosApi'
import { isWeixin, fenxiang, basepath } from '../../assets/common/js/config'
import Scroller from '../common/Scroller'
export default {
  name: 'inviteFriends',
  data () {
    return {
      ceil: false,
      scrollTop: null,
      isScroll: null,
      showshare: false,
      list: [],
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: ''
    }
  },
  components: {
    Scroller
  },
  mounted: function () {
    var that = this
    that.$nextTick(() => {
      if (that.$refs.ifscroll) {
        that.isScroll = that.$refs.ifscroll.offsetTop
      }
      window.addEventListener('scroll', that.scrollWatch)
    })
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter (to, from, next) {
    if (from.path == '/') { // 当前页面刷新不需要切换位置
      next(vm => {
        window.addEventListener('scroll', vm.scrollWatch)
        vm.recommend = false
        vm.nowPage = 0
      })
    } else {
      next(vm => {
        window.addEventListener('scroll', vm.scrollWatch)
        // vm.recommend = false
        // vm.nowPage = 0
        // vm.onInfinite()
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    next()
  },
  methods: {
    getData: function () {
      var url = 'Wxmall/User/getShareList?pageNo=' + this.nowPage + '&pageSize=' + this.pagesize
      var that = this
      customRequestAjax(url).then(res => {
        if (res.data.code === 200) {
          if (that.nowPage == 1) {
            that.list = res.data.list
            that.refresh = false
          } else {
            that.list = that.list.concat(res.data.list)
          }
          that.loading = false
          if (res.data.list.length < that.pagesize) {
            that.finished = true
            that.recommend = true
          } else {
            that.recommend = false
            that.finished = false
          }
          if (isWeixin()) {
            fenxiang({
              title: encodeURIComponent('好友送福利'),
              desc: encodeURIComponent('海量商品等你来，戳一戳有惊喜'),
              imgx: basepath + '/static/images/friends.jpg',
              type: 'index',
              dataStr: 'type=index',
              path: 'inviteFriends'
            })
          }
        }
      })
    },
    onRefresh () {
      this.refresh = true
      this.recommend = false
      this.nowPage = 1
      // this.list = []
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      this.recommend = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData()
      // }, 400)
    },
    scrollWatch: function () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      this.scrollTop = scrollTop
      if (scrollTop > this.isScroll) {
        this.ceil = true
      } else {
        this.ceil = false
      }
    },
    share () {
      this.showshare = true
    }
  }
}
</script>

<style scoped lang="scss">
.invFriends {
  background: #0B2481 url(../../assets/images/invfriends.png) no-repeat 0 0;
  background-size: 100%;
  padding-top: 96.5%;
  padding-bottom: 0.27rem;
  >img {
    width: 100%;
    padding: 0 0.11rem;
    margin-bottom: 0.22rem;
    &.ceiling {
      position: fixed;
      left: 0;
      right: 0;
      top: 0.08rem;
      z-index: 20;
    }
  }
  .list {
    margin:0 0.11rem 0;
    background: #3670FF;
    border-radius: 0.04rem;
    padding: 0 0.15rem 0.2rem;
    >img {
      width: 100%;
      position: relative;
      top: -0.12rem;
    }
    ul {
      li {
        display: flex;
        display: -ms-flex;
        display: -moz-flex;
        display: -o-flex;
        display: -webkit-flex;
        align-items: center;
        -ms-align-items: center;
        -moz-align-items: center;
        -o-align-items: center;
        -webkit-align-items: center;
        margin-bottom: 0.1rem;
        &:last-of-type {
          margin-bottom: 0;
        }
        >img {
          width: 0.55rem;
          height: 0.55rem;
          border-radius: 50%;
        }
        .title {
          flex: 1;
          -ms-flex: 1;
          -moz-flex: 1;
          -o-flex: 1;
          -webkit-flex: 1;
          margin-left: 0.1rem;
          p {
            font-size:0.15rem;
            font-family:'PingFangSC';
            font-weight:600;
            color:rgba(255,255,255,1);
            line-height:0.21rem;
          }
          span {
            display: block;
            font-size:0.13rem;
            font-family:'PingFangSC';
            font-weight:400;
            color:rgba(125,165,255,1);
            line-height:0.18rem;
          }
        }
        >b {
          display: block;
          padding: 0.03rem 0.11rem;
          background:rgba(249,242,232,1);
          border-radius:0.13rem;
          border:1px solid rgba(22,22,22,1);
          font-size:0.14rem;
          font-family:'PingFangSC';
          font-weight:400;
          color:rgba(197,139,83,1);
          line-height:0.2rem;
        }
      }
    }
  }
}
.sharecontainer {
  position: fixed;
  width: 100%;
  z-index: 100;
  height: 100%;
  left: 0;
  top: 0;
  background:rgba(0,0,0,0.69);
  img {
    position: absolute;
    top: 0;
    right: .35rem;
    width: 1.53rem;
  }
  .know {
    width: 1.09rem;
    height: .36rem;
    line-height: .36rem;
    color: #fff;
    border-color: #fff;
    background: transparent;
    position: absolute;
    bottom: 1.5rem;
    left: 50%;
    margin-left: -.54rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/inviteFriends.vue